module.exports = __webpack_public_path__ + "static/easyinvoice-5bd5900004eaee2ec09a29d376a70279.png";